import { normalizeIconName as e } from "../../utils/iconNames.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/checkbox/CheckboxIcon.tsx
var r = (r) => {
	let { iconName: i, icon: a, iconSize: o, iconLabelPosition: s, text: c } = r, l = i ?? a ?? "", u = {
		width: `${o}px`,
		height: `${o}px`,
		fontSize: `${o}px`,
		lineHeight: `${o}px`
	};
	return /* @__PURE__ */ n("span", {
		className: `checkbox-icon label-${s}`,
		children: [/* @__PURE__ */ t("span", {
			className: `uikit-icon ${e(l)}`,
			style: u
		}), /* @__PURE__ */ t("span", {
			className: "checkbox-label",
			children: c
		})]
	});
};
//#endregion
export { r as CheckboxIcon };

//# sourceMappingURL=CheckboxIcon.js.map